export default __webpack_public_path__ + "static/media/10_podworko.c1767c5f.png";